var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBep20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "binance",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.285,
    height: 27.286,
    viewBox: "0 0 27.285 27.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M27.494,11.465l5.3-5.3,5.3,5.3,3.082-3.084L32.793,0,24.41,8.383Z",
    transform: "translate(-19.148)",
    fill: "#f3ba2f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M0,0H4.36V4.36H0Z",
    transform: "translate(0 13.644) rotate(-45)",
    fill: "#f3ba2f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M27.478,73.4l5.3,5.3,5.3-5.3,3.084,3.08,0,0-8.383,8.386-8.383-8.381,0,0Z",
    transform: "translate(-19.133 -57.581)",
    fill: "#f3ba2f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M0,0H4.36V4.36H0Z",
    transform: "translate(21.12 13.644) rotate(-45)",
    fill: "#f3ba2f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M55.039,51.909,51.911,48.78,49.6,51.092l-.267.265-.547.547,0,0,0,.006,3.127,3.125,3.127-3.129,0,0Z",
    transform: "translate(-38.266 -38.267)",
    fill: "#f3ba2f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBep20);
export default __webpack_public_path__ + "static/media/bep20.816ecb41750cda114f6fd4b42a9620cc.svg";
export { ForwardRef as ReactComponent };